module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-input-page"
  }, [_c('payment-success', {
    ref: "paymentSuccess",
    attrs: {
      "account-category": _vm.accountCategory
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8781320","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/onboarding/authPlan.vue
// module id = 1859
// module chunks = 180